import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private router: Router,
    private http: HttpClient) { }

  createUser(user) {
    return this.http.post(`${environment.url}/auth/create-account`, user);
  }

  startSignupCheckout(signup: SignupCheckoutRequest): Observable<{ status: boolean; data: { url: string } }> {
    return this.http.post<{ status: boolean; data: { url: string } }>(`${environment.url}/zoho/signup/checkout`, signup);
  }

  /** Demo path: no Zoho hosted page; creates Zoho customer + LBN demoMode company. */
  startDemoSignup(signup: SignupDemoRequest): Observable<{ status: boolean; data: { ok: boolean } }> {
    return this.http.post<{ status: boolean; data: { ok: boolean } }>(`${environment.url}/zoho/signup/demo`, signup);
  }

  login(user: User): Observable<any> {
    return this.http.post(`${environment.url}/auth/login`, user);
  }

  forgotPassword(email: string): Observable<any> {
    return this.http.post(`${environment.url}/auth/forgot-password`, { username: email })
  }

  changePassword(password: string, token: string): Observable<any> {
    return this.http.post(`${environment.url}/auth/change/password`, { password, token })
  }

  verifyAccount(token): Observable<any> {
    return this.http.post(`${environment.url}/auth/verify/account`, token)
  }

  generateCompanyToken(): Observable<any> {
    return this.http.post(`${environment.url}/auth/company-token`, {})
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['/login'])
  }

  loginReports(userId: string, companyId: string): Observable<{ token: string }> {
    return this.http.post<{ token: string }>(`${environment.analyticsAPI}/reports/user/authentication`, {
      userId,
      companyId,
      database: environment.production ? 'production' : 'development'
    })
  }
}

interface User {
  username: string;
  password: string;
}

export interface SignupCheckoutRequest {
  businessType:
    | 'Broker'
    | 'Carrier'
    | 'Shipper'
    | 'Broker/Carrier'
    | '3PL'
    | 'Freight Forwarder'
    | 'Other';
  planCode: string;
  email: string;
  companyName: string;
  phone: string;
  address1?: string;
  city?: string;
  state: string;
  postalCode: string;
  country?: string;
  firstName: string;
  lastName: string;
  dotNumber?: string;
  mcNumber?: string;
}

/** Same fields as checkout without planCode (demo has no Zoho plan yet). */
export type SignupDemoRequest = Omit<SignupCheckoutRequest, 'planCode'>;
